import { render, staticRenderFns } from "./ShipmentDocumentation.vue?vue&type=template&id=4250ead0&"
import script from "./ShipmentDocumentation.vue?vue&type=script&lang=js&"
export * from "./ShipmentDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDocumentation.vue?vue&type=style&index=0&id=4250ead0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports